"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EditableCoverageDetails = void 0;
var core_ui_1 = require("@newfront-insurance/core-ui");
var react_1 = __importStar(require("react"));
var react_use_1 = require("react-use");
var coverage_edit_modal_1 = require("./components/coverage-edit-modal");
var coverage_expandable_row_1 = require("./components/coverage-expandable-row");
function EditableCoverageDetails(_a) {
    var identifier = _a.identifier, lineOfCoverageDetails = _a.lineOfCoverageDetails, onUpdate = _a.onUpdate, isDeletable = _a.isDeletable, onDelete = _a.onDelete, _b = _a.isUpdating, isUpdating = _b === void 0 ? false : _b, isEditable = _a.isEditable;
    var _c = react_use_1.useToggle(false), isModalOpen = _c[0], setIsModalOpen = _c[1];
    var modalContainerRef = react_1.useRef(null);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(coverage_expandable_row_1.CoverageExpandableRow, { identifier: identifier, lineOfCoverageDetails: lineOfCoverageDetails, onSetIsModalOpen: setIsModalOpen, isDeletable: isDeletable, onDelete: onDelete, isUpdating: isUpdating, isEditable: isEditable }),
        react_1.default.createElement("div", { ref: modalContainerRef },
            react_1.default.createElement(core_ui_1.ModalPortalProvider, { elementRef: modalContainerRef },
                react_1.default.createElement(coverage_edit_modal_1.EditCoverageDetailsModal, { identifier: identifier, lineOfCoverageDetails: lineOfCoverageDetails, isModalOpen: isModalOpen, onSetIsModalOpen: setIsModalOpen, onUpdate: onUpdate })))));
}
exports.EditableCoverageDetails = EditableCoverageDetails;
